<div class="cg-margin-bottom-xs">
  <strong data-test="wam-table-user-name"
    >{{ user.lastName }}, {{ user.firstName }}</strong
  ><br />
  <button
    *ngIf="allowView"
    cignaButton="link"
    style="padding: 0.25em 0"
    data-test="wam-table-user-view-link"
    (click)="viewAccessForUser.emit(user)"
    [cignaTrackClicks]="[
      'trackEventOther',
      'View access',
      'ac-WC018-View Access'
    ]"
  >
    View access
  </button>
</div>
<div
  class="cg-margin-bottom-xs"
  *ngIf="(user.temporaryUserName || user.id) && mode === 'view'"
>
  <span
    data-test="wam-table-user-temp-id"
    *ngIf="
      user.temporaryUserName && (!user.ssoId || user.id.startsWith('__new__'))
    "
    >{{ user.temporaryUserName }} (Temp User ID)</span
  >
  <span
    *ngIf="user.ssoId && !user.id.startsWith('__new__')"
    data-test="button-wam-table-user-sso-id"
    >{{ user.id }}</span
  >
</div>
<div
  data-test="wam-table-user-temp-pw"
  class="cg-margin-bottom-xs"
  *ngIf="
    user.temporaryPassword &&
    (!user.ssoId || user.id.startsWith('__new__')) &&
    mode === 'view'
  "
>
  {{ user.temporaryPassword }} (Temp Password)
</div>
<div class="cg-margin-bottom-xs" *ngIf="user.jobRole && showJobRole">
  {{ user.jobRole }}
</div>
<div data-test="lbl-email" class="cg-margin-bottom-xs">{{ user.email }}</div>
<div data-test="lbl-phone" class="cg-margin-bottom-xs" *ngIf="user.phone">
  {{ user.phone | phoneNumber }}
</div>
<div class="cg-margin-bottom-xs" *ngIf="mode === 'edit' && allowRemove">
  <button
    data-test="button-wam-user-edit-remove"
    cignaButton="link"
    class="cg-flush-button-link"
    (click)="removeUserFromEdit.emit(user)"
  >
    Remove user from editing
  </button>
</div>
